module.exports = __webpack_public_path__ + "static/box-man-378a815b43d1d9d2e490b3cb80998f98.jpeg";